// src/features/equipment/pages/EquipmentDetailsPage/components/EquipmentHeader.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Chip,
} from '@mui/material';
import {
  Edit as EditIcon,
  ReportProblem as ReportProblemIcon,
} from '@mui/icons-material';
import { UUIDDisplay } from '../../../../../utils/formatters/uuid';

import PageHeader from '../../../../../components/common/PageHeader';
import EquipmentStatusChip from '../../../components/EquipmentStatusChip';

// Faults can be reported on equipment that isn't already under repair or retired
const REPORTABLE = ['operational', 'out_of_service'];

export default function EquipmentHeader({
  equipment, canUpdate, onBack, onEdit, maintenanceActions, openCases = [],
}) {
  const { t } = useTranslation(['equipment', 'common']);
  // A device that's still "in service" but has a fault reported shouldn't look healthy
  const hasReports = openCases.some(c => c.status === 'reported');
  const shownStatus = equipment.status === 'operational' && hasReports ? 'fault_reported' : equipment.status;

  return (
    <PageHeader
      onBack={onBack}
      title={equipment.name}
      badges={<>
        <EquipmentStatusChip status={shownStatus} />
        <Chip
          label={t(`equipment:equipment_types.${equipment.equipment_type}`)}
          size="small"
          color="primary"
          variant="outlined"
        />
      </>}
      subtitle={<>{t('common:labels.id')} <UUIDDisplay uuid={equipment.equipment_id} /></>}
      actions={<>
        {maintenanceActions?.canReport && REPORTABLE.includes(equipment.status) && (
          <Button
            variant="outlined"
            color="warning"
            startIcon={<ReportProblemIcon />}
            onClick={maintenanceActions.openReport}
          >
            {t('equipment:maintenance.actions.report_fault')}
          </Button>
        )}
        {canUpdate && (
          <Button
            variant="contained"
            startIcon={<EditIcon />}
            onClick={onEdit}
          >
            {t('equipment:actions.edit')}
          </Button>
        )}
      </>}
    />
  );
}
